import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  untracked,
} from '@angular/core';
import { OutcomeAnalytics } from '../../analytics/outcome-analytics';
import { DialogService } from 'primeng/dynamicdialog';
import { Skeleton } from 'primeng/skeleton';
import { OutcomeCardComponent } from '../outcome-card/outcome-card.component';
import { OutcomeModalService } from '../outcome-modal.service';
import { OutcomesStore } from '../outcomes.store';

@Component({
  selector: 'bn-unlinked-outcomes-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Skeleton, OutcomeCardComponent],
  providers: [DialogService, OutcomeModalService],
  templateUrl: './unlinked-outcomes-list.component.html',
  styleUrl: './unlinked-outcomes-list.component.scss',
})
export class UnlinkedOutcomesListComponent {
  readonly store = input.required<OutcomesStore>();
  readonly modal = inject(OutcomeModalService);
  private readonly analytics = inject(OutcomeAnalytics);
  constructor() {
    let viewedSession: ReturnType<OutcomesStore['session']> = null;
    effect(() => {
      const store = this.store();
      const session = store.session();
      if (
        !session ||
        session === viewedSession ||
        store.loading() ||
        store.error() ||
        !store.data()
      )
        return;
      viewedSession = session;
      untracked(() =>
        this.analytics.log('unlinked_outcomes_tab_viewed', session, {
          unlinked_count: store.outcomes().length,
        }),
      );
    });
    effect(() => {
      this.store().session();
      this.modal.reset();
    });
  }
}
